import { defineMessages, useIntl } from "react-intl";

import {
  MutationActions,
  useEntityMutation,
  QueryKeys,
  queryClient,
} from "@/api/core";
import { useApi } from "@/hooks";
import { statusSchema, type Group, type Status } from "@/schemas";
import toast from "@/toast";

const messages = defineMessages({
  unpinSuccess: {
    id: "status.group_unpin.success",
    defaultMessage: "Unpinned from group",
  },
});

interface Variables {
  id: string;
}

function useUnpinStatusFromGroup(group: Group, status: Status) {
  const api = useApi();
  const intl = useIntl();

  return useEntityMutation({
    globalQueryKey: QueryKeys.statuses.global,
    action: MutationActions.UPDATE,
    schema: statusSchema,
    mutationFn: (variables: Variables) =>
      api.post<Status>(
        `/api/v1/groups/${group.id}/statuses/${variables.id}/unpin`,
      ),
    setNextEntity() {
      return {
        ...status,
        pinned: false,
      };
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: QueryKeys.statuses.groupTimeline(group.id, true),
      });
      toast.success(intl.formatMessage(messages.unpinSuccess));
    },
  });
}

export { useUnpinStatusFromGroup };
